"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var material_kit_pro_react_1 = require("../../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        container: material_kit_pro_react_1.container,
        content: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center'
        },
        dialog: {
            backgroundColor: theme.palette.background.default,
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        dialogActions: {
            padding: theme.spacing(2)
        },
        titleText: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                marginTop: 24,
                marginBottom: 16
            },
            _a[theme.breakpoints.up('sm')] = {
                marginTop: 32,
                marginBottom: 32
            },
            _a),
        text: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: theme.spacing(3)
        },
        closeText: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        primaryText: {
            color: theme.palette.primary.main
        },
        buttonText: {
            color: theme.palette.common.white
        },
        linkButton: {
            marginBottom: theme.spacing(2),
            width: '60%'
        },
        mailIcon: {
            fontSize: '120px'
        },
        resendButtonContainer: { textAlign: 'center' }
    });
};
var ResendActivationEmailSentDialog = function (_a) {
    var show = _a.show, email = _a.email, okayCallback = _a.okayCallback;
    var theme = (0, core_1.useTheme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var useStyles = (0, core_1.makeStyles)(styles);
    var classes = useStyles(theme);
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": "account-reactivation-dialog", open: show, className: 'po-widget-dialog', PaperProps: {
            className: classes.dialog
        } },
        react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.DialogTitle, { id: "alert-dialog-slide-title", disableTypography: true },
                react_1.default.createElement(core_1.Typography, { variant: "h6", id: "modal-title", align: 'center' }, "Re-send Activation Email Sent")),
            react_1.default.createElement(core_1.DialogContent, { id: "account-reactivation-dialog" },
                react_1.default.createElement("div", { className: classes.content },
                    react_1.default.createElement(core_1.Icon, { color: "primary", className: classes.mailIcon }, "mail")),
                react_1.default.createElement("div", { className: classes.closeText },
                    react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body2" }, "Account activation instructions sent to")),
                react_1.default.createElement("div", { className: classes.text },
                    react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "subtitle2" }, email)),
                react_1.default.createElement("div", { className: classes.text },
                    react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body2" }, "Go to")),
                react_1.default.createElement("div", { className: classes.resendButtonContainer },
                    react_1.default.createElement(core_1.Button, { className: classes.linkButton, onClick: okayCallback, size: "large", color: "primary", variant: "contained", "aria-label": "sign in" },
                        react_1.default.createElement(core_1.Typography, { variant: "button", className: classes.buttonText }, "SIGN IN")),
                    react_1.default.createElement(core_1.Button, { className: classes.linkButton, style: { marginBottom: '0' }, onClick: okayCallback, color: "primary", variant: "text", "aria-label": "home" },
                        react_1.default.createElement(core_1.Typography, { variant: "button", className: classes.primaryText }, "HOME")))))));
};
exports.default = ResendActivationEmailSentDialog;
//# sourceMappingURL=ResendActivationEmailSentDialog.js.map